import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { getTemplateById } from "../../reducers/template";
import PreviewBackArrow from "../../components/back-arrow/back-arrow";

import { primary_s26_l96 } from "../../shared/lib/colors";

import Header from "../../shared/HeaderTemplate/Header";
import Footer from "../../shared/FooterTemplate/Footer";
import Home from "./Home";

import "../../styles/style.scss";
import "../../styles/style.less";

moment.locale("it");

class App extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const { templateId } = this.props.match.params;
    // console.log("template:", templateId);
    this.props.getTemplateById(templateId);
  }
  renderBackgroundVersion = (uiVariantBackground) => {
    switch (uiVariantBackground) {
      case "1":
        return primary_s26_l96(this.props.primaryColor);
      case "2":
        return "#f6f6f6";
      case "3":
        return "#fff";
      default:
        return primary_s26_l96(this.props.primaryColor);
    }
  };

  render() {
    const isCheckout = false;
    return (
      <div className={isCheckout ? "is-checkout" : "is-not-checkout"}>
        <PreviewBackArrow />
        <div
          className="global-wrapper"
          style={{
            backgroundColor: this.renderBackgroundVersion(
              "1"
              // this.props.uiVariantBackground
            ),
          }}
        >
          <Header isCheckout={isCheckout} />
          <Home />
          <div className="push" />
        </div>
        <Footer isCheckout={isCheckout} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    siteName: state.template.singleTemplate.siteName,
    favicon: state.template.singleTemplate.faviconImage,
    primaryColor: state.template.singleTemplate.brandColor,
    uiVariantBackground: state.template.singleTemplate.background,
  };
};

export default connect(mapStateToProps, { getTemplateById })(App);
